module.exports = __webpack_public_path__ + "img/tour2.4c7fc4f9.png";